<template>
  <div class="container">
    <div class="d-flex justify-content-center align-items-center" id="main">
      <h1 class="mr-3 pr-3 align-top border-right inline-block align-content-center"><i class="fas fa-qrcode"></i></h1>
      <div class="inline-block align-middle">
        <h2 class="font-weight-normal lead" id="desc">QRCode não encontrado</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">

#main {
    height: 90vh;
}

#desc {
  font-size: 1.50rem;
}

</style>
